import { localeFallbacks } from '../../var/translations/configuration'
import { trans as baseTrans, setLocaleFallbacks } from '@symfony/ux-translator'
import * as allMessages from '../../var/translations'
/*
 * This file is part of the Symfony UX Translator package.
 *
 * If folder "app/assets/translations" does not exist, or some translations are missing,
 * you must warmup your Symfony cache to refresh JavaScript translations.
 *
 * If you use TypeScript, you can rename this file to "translator.ts" to take advantage of types checking.
 */

setLocaleFallbacks(localeFallbacks)

declare const accountName: string

interface TranslationMessage {
  id: string
  translations: Record<string, Record<string, string>>
}

const messagesById = new Map<string, TranslationMessage>(
  (Object.values(allMessages) as unknown[])
    .filter((m): m is TranslationMessage =>
      typeof m === 'object' && m !== null && 'id' in m && 'translations' in m)
    .map(m => [m.id, m])
)

const getLocale = () => {
  return document.documentElement.getAttribute('data-symfony-ux-translator-locale') ||
    document.documentElement.lang ||
    'en'
}

const trans = (...[message, parameters, domain, locale]: Parameters<typeof baseTrans>): string => {
  const account = typeof accountName === 'undefined' ? '' : accountName
  if (account !== '') {
    const override = messagesById.get(`${account}.${(message as TranslationMessage).id}`)
    if (override !== undefined) {
      const translated = baseTrans(override as Parameters<typeof baseTrans>[0], parameters, domain, locale)
      if (translated !== override.id) {
        return translated
      }
    }
  }
  return baseTrans(message, parameters, domain, locale)
}

export { trans, getLocale }

export * from '../../var/translations'
